import { useEffect, useState } from 'react';
import { apiRequest } from '../../api/http';

type Mission = { platform: string; creator_reward: number; status: string; note?: string };
type Evidence = { campaign_name: string; base_status: string; can_moderate: boolean; missions: Mission[]; items: { platform: string; url: string }[] };
const names: Record<string, string> = { instagram: 'Instagram', tiktok: 'TikTok', facebook: 'Facebook', youtube: 'YouTube' };
export function SocialBonusPage({ reviewId }: { reviewId: string }) {
  const [data, setData] = useState<Evidence>();
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [notes, setNotes] = useState<Record<string, string>>({});
  const [links, setLinks] = useState<Record<string, string>>({});
  const path = `/reviews/${encodeURIComponent(reviewId)}/campaign-evidence`;
  const load = () => apiRequest<Evidence>(path).then(value => { setData(value); setLinks(Object.fromEntries(value.items.map(i => [i.platform, i.url]))); }).catch(e => setError(String(e.message)));
  useEffect(() => { void load(); }, [reviewId]);
  async function decide(m: Mission, approve: boolean) {
    if (!approve && !notes[m.platform]?.trim()) { setError('กรุณาระบุเหตุผลที่ให้แก้ไข'); return; }
    setBusy(true); setError('');
    try {
      await apiRequest(`/admin/reviews/${encodeURIComponent(reviewId)}/social-bonuses/${m.platform}`, { method: 'POST', body: { approve, note: notes[m.platform] || '' } });
      await load();
    } catch (e) { setError(e instanceof Error ? e.message : 'บันทึกไม่สำเร็จ'); }
    finally { setBusy(false); }
  }
  async function submit(platform: string) {
    setBusy(true); setError('');
    try {
      await apiRequest(path, { method: 'PUT', body: { submit: true, items: [{ platform, url: links[platform] || '' }] } });
      await load();
    } catch (e) { setError(e instanceof Error ? e.message : 'ส่งหลักฐานไม่สำเร็จ'); }
    finally { setBusy(false); }
  }
  return <main style={{ maxWidth: 680, margin: '32px auto', padding: 20 }}>
    <h1>ภารกิจโบนัส</h1>{error && <p role="alert">{error}</p>}
    {!data ? <p>กำลังโหลด…</p> : <>
      <h2>{data.campaign_name}</h2><p>รีวิว Beaw Club · {data.base_status === 'paid' ? 'ได้รับรางวัลแล้ว' : 'รอตรวจรางวัล'}</p>
      <p>โบนัสเป็นทางเลือกเพิ่มเติม ตรวจและอนุมัติแยกทีละแพลตฟอร์มได้</p>
      {data.missions.map(m => { const url = data.items.find(i => i.platform === m.platform)?.url; return <section key={m.platform} style={{ border: '1px solid #dce4f5', borderRadius: 16, padding: 16, marginTop: 12 }}>
        <h3>โพสต์บน {names[m.platform] || m.platform} รับเพิ่ม {m.creator_reward} บาท</h3>
        <p>{({ submitted: 'รอตรวจหลักฐาน', processing: 'กำลังจ่าย · กดอนุมัติเพื่อดำเนินการต่อ', approved: 'ได้รับโบนัสแล้ว', included: 'รวมในรางวัลเดิมแล้ว', rejected: 'ให้แก้ไข', available: 'ยังไม่ได้ส่ง', draft: 'แบบร่าง' } as Record<string, string>)[m.status]}</p>
        {m.note && <p>{m.note}</p>}{url && <a href={url} target="_blank" rel="noreferrer">เปิดโพสต์หลักฐาน</a>}
        {!data.can_moderate && ['available', 'draft', 'rejected'].includes(m.status) && <div style={{ display: 'grid', gap: 10, marginTop: 12 }}><input aria-label={`ลิงก์ ${m.platform}`} placeholder="https://..." type="url" value={links[m.platform] || ''} onChange={e => setLinks({ ...links, [m.platform]: e.target.value })} /><button className="button button--primary" disabled={busy} onClick={() => void submit(m.platform)}>ส่งหลักฐานแพลตฟอร์มนี้</button></div>}
        {data.can_moderate && ['submitted', 'processing'].includes(m.status) && <div style={{ display: 'grid', gap: 10, marginTop: 12 }}>
          <textarea aria-label={`เหตุผล ${m.platform}`} placeholder="เหตุผลเมื่อให้แก้ไข" value={notes[m.platform] || ''} onChange={e => setNotes({ ...notes, [m.platform]: e.target.value })} />
          <button className="button button--primary" disabled={busy || data.base_status !== 'paid'} onClick={() => void decide(m, true)}>อนุมัติโบนัสดังกล่าว</button>
          <button className="button" disabled={busy || m.status === 'processing'} onClick={() => void decide(m, false)}>ส่งกลับแก้ไข</button>
        </div>}
      </section>; })}
    </>}
  </main>;
}
